<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="订单号：">
            <el-input v-model="query.orderNum" placeholder="请输入订单号" clearable size="small" />
          </el-form-item>
          <el-form-item label="活动名称：">
            <el-input v-model="query.activityName" placeholder="请输入活动名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="支付模式：">
            <el-select v-model="query.payMode" placeholder="请选择" clearable size="small">
              <el-option v-for="item in payModeOptions" :key="item.key" :label="item.value" :value="item.key" />
            </el-select>
          </el-form-item>
          <el-form-item label="赠品类型：">
            <el-select v-model="query.rewardType" placeholder="请选择" clearable size="small">
              <el-option v-for="item in rewardTypeOptions" :key="item.key" :label="item.value" :value="item.key" />
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.status" placeholder="请选择" clearable size="small">
              <el-option v-for="item in statusOptions" :key="item.key" :label="item.value" :value="item.key" />
            </el-select>
          </el-form-item>
          <el-form-item label="登记时间：">
            <el-date-picker v-model="dateRange" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                            start-placeholder="开始时间" end-placeholder="结束时间" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="handleQuery">查询</el-button>
            <el-button type="info" size="mini" plain @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="box-card mt10">
      <div class="hint">
        这里记录的是<b>活动赠品的发放过程</b>：下单时登记「待发放」，支付成功后发放置「已发放」，
        整单取消回退置「已回退」。查「这单到底送没送出去、为什么失败」看这里。
        <br/>
        「支付时活动已失效」是指客户付款那一刻活动已经结束或被停用，<b>属于正常结果，不需要补发</b>，
        原因在「失败原因」列，客户在 App 支付成功页看到的是同一句话。
      </div>
      <el-table v-loading="listLoading" :data="list" size="small">
        <el-table-column label="订单号" prop="orderNum" align="center" width="180">
          <template slot-scope="{row}">{{row.orderNum || '-'}}</template>
        </el-table-column>
        <el-table-column label="客户" prop="customerName" align="center" width="120">
          <template slot-scope="{row}">{{row.customerName || '-'}}</template>
        </el-table-column>
        <el-table-column label="活动" prop="activityName" align="center" min-width="160" show-overflow-tooltip>
          <!-- 活动被删除后流水仍在，活动名会是空，这不是数据错误 -->
          <template slot-scope="{row}">{{row.activityName || ('活动已删除(id=' + row.activityId + ')')}}</template>
        </el-table-column>
        <el-table-column label="支付模式" prop="payModeName" align="center" width="110">
          <template slot-scope="{row}">{{row.payModeName || '-'}}</template>
        </el-table-column>
        <el-table-column label="赠品类型" prop="rewardTypeName" align="center" width="100">
          <template slot-scope="{row}">{{row.rewardTypeName || '-'}}</template>
        </el-table-column>
        <el-table-column label="数量/金额" prop="rewardValue" align="center" width="100">
          <template slot-scope="{row}">{{row.rewardValue == null ? '-' : row.rewardValue}}</template>
        </el-table-column>
        <!-- 宽度 100 会把最长的状态名「支付时活动已失效」截成「支付时活动已失」，
             看起来像另一种状态。按 8 个汉字留 140。 -->
        <el-table-column label="状态" align="center" width="140">
          <template slot-scope="{row}">
            <el-tag size="mini" :type="statusTagType(row.status)">{{row.statusName || '-'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="失败原因" prop="failReason" align="center" min-width="160" show-overflow-tooltip>
          <template slot-scope="{row}">{{row.failReason || '-'}}</template>
        </el-table-column>
        <el-table-column label="登记时间" prop="createdTime" align="center" width="160" />
        <el-table-column label="最后变更" prop="operatedTime" align="center" width="160">
          <template slot-scope="{row}">{{row.operatedTime || '-'}}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="90" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="showDetail(row)" :disabled="!row.rewardDetail && row.rewardValue == null">赠品明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize"
                  @pagination="doQueryList" />
    </el-card>

    <el-dialog title="赠品明细" :visible.sync="detailVisible" width="720px" append-to-body>
      <template v-if="detailRecord.rewardType === 'GOODS'">
        <template v-if="detailItems && detailItems.length">
          <p class="hint">数量按本条发放记录显示；未保存下单名称时，标注为当前商品资料。</p>
          <el-table :data="detailItems" size="small" border>
            <el-table-column label="赠品名称" min-width="220">
              <template slot-scope="{row}">
                <div>{{row.goodsName || '商品资料缺失'}}</div>
                <small class="gift-source">SKU：{{row.skuId == null ? '未记录' : row.skuId}}<span v-if="row.nameSource === 'CURRENT'"> · 当前商品资料</span></small>
              </template>
            </el-table-column>
            <el-table-column label="聚水潭编码" min-width="130">
              <template slot-scope="{row}">{{row.jushuitanCode || '未记录'}}</template>
            </el-table-column>
            <el-table-column label="规格" min-width="140">
              <template slot-scope="{row}">{{row.spec || row.specTitle || '未记录'}}</template>
            </el-table-column>
            <el-table-column label="数量（件）" width="110" align="center">
              <template slot-scope="{row}"><span data-gift-quantity>{{row.num == null ? '未记录' : row.num}}</span></template>
            </el-table-column>
          </el-table>
        </template>
        <p v-else-if="detailItems || !detailText">未记录赠品明细</p>
        <p v-else>赠品明细无法解析，请查看原始记录。</p>
      </template>
      <p v-else>{{detailRecord.rewardTypeName || '赠送数量/金额'}}：{{detailRecord.rewardValue == null ? '未记录' : detailRecord.rewardValue}}</p>
      <details v-if="detailText" class="raw-detail" :open="!detailItems">
        <summary>原始记录</summary>
        <pre class="detail-json">{{detailText}}</pre>
      </details>
      <div slot="footer">
        <el-button size="small" @click="detailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 活动赠品发放流水（REQ-2026-826259）
 *
 * 数据源 goods_activity_reward_log —— 这张表一直在写，只是此前没有任何查询入口。
 */
import request from '@/utils/request'
import Pagination from '@/components/Pagination'

function initQuery() {
  return {
    pageNo: 1,
    pageSize: 20,
    orderNum: '',
    activityName: '',
    payMode: '',
    rewardType: '',
    status: undefined
  }
}

export default {
  name: 'ActivityRewardLog',
  components: { Pagination },
  data() {
    return {
      query: initQuery(),
      dateRange: [],
      list: [],
      total: 0,
      listLoading: false,
      detailVisible: false,
      detailText: '',
      detailRecord: {},
      detailItems: null,
      // 选项的中文与后端 ActivityPayMode / statusName 同义
      payModeOptions: [
        { key: 'CASH', value: '现金购买' },
        { key: 'BALANCE', value: '余额购买' },
        { key: 'XIAODUBI', value: '小杜币购买' },
        { key: 'GIFT', value: '赠送账户购买' }
      ],
      rewardTypeOptions: [
        { key: 'GOODS', value: '实物赠品' },
        { key: 'BALANCE', value: '余额' },
        { key: 'XIAODUBI', value: '小杜币' },
        { key: 'GIFT', value: '学费赠送' }
      ],
      statusOptions: [
        { key: 0, value: '待发放' },
        { key: 1, value: '已发放' },
        { key: 2, value: '已回退' },
        { key: 3, value: '发放失败' },
        // REQ-2026-826259 问题3：活动有效性按**支付时刻**判定，付款那一刻活动已结束/停用就不发。
        // 与「发放失败」分开：这条不是故障、不用补发，客户在 App 上也看得到原因。
        { key: 4, value: '支付时活动已失效' }
      ]
    }
  },
  created() {
    this.doQueryList({})
  },
  methods: {
    calcQuery() {
      const params = { ...this.query }
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.dateRange[0]
        params.endTime = this.dateRange[1]
      } else {
        params.startTime = undefined
        params.endTime = undefined
      }
      return params
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) this.query.pageNo = pageNo
      if (pageSize) this.query.pageSize = pageSize
      this.listLoading = true
      return request.get('/activity/goodsActivity/rewardLog', { params: this.calcQuery() })
        .then(({ data }) => {
          this.list = (data && data.list) || []
          this.total = (data && data.total) || 0
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    handleReset() {
      this.query = initQuery()
      this.dateRange = []
      this.doQueryList({ pageNo: 1 })
    },
    statusTagType(status) {
      // 4 用 info 不用 danger：它是正常的业务结果，不是故障，标红会让运营以为要去补发
      const map = { 0: 'warning', 1: 'success', 2: 'info', 3: 'danger', 4: 'info' }
      return map[status] || 'info'
    },
    showDetail(row) {
      // Keep raw history available; selected quantities and name provenance come from this ledger's projection.
      this.detailRecord = row
      this.detailItems = Array.isArray(row.giftItems) ? row.giftItems : null
      let text = row.rewardDetail || ''
      try {
        text = JSON.stringify(JSON.parse(text), null, 2)
      } catch (e) {
        // 保持原文
      }
      this.detailText = text
      this.detailVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.hint {
  color: #909399;
  font-size: 12px;
  line-height: 1.8;
  margin-bottom: 10px;
}
.detail-json {
  max-height: 420px;
  overflow: auto;
  background: #f5f7fa;
  padding: 10px;
  font-size: 12px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
}
.gift-source { color: #909399; }
.raw-detail { margin-top: 16px; }
.raw-detail summary { cursor: pointer; }
</style>
